/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-vars */
import blocksService from '@/modules/Flexigo/services/blocks';

const initialState = {
  blocks: [],
  isLoading: false,
  error: null,
};

const state = () => ({ ...initialState });

const mutations = {
  SET_BLOCKS(storeState, payload) {
    storeState.blocks = payload;
  },
  SET_IS_LOADING(storeState, payload) {
    storeState.isLoading = payload;
  },
  SET_ERROR(storeState, payload) {
    storeState.error = payload;
  },
  CLEAR_ERROR(storeState) {
    storeState.error = null;
  },
};

const actions = {
  async getBlocks({ commit }) {
    commit('SET_IS_LOADING', true);
    commit('CLEAR_ERROR');
    try {
      const response = await blocksService.getBlocks();
      commit('SET_BLOCKS', response || []);
      return response;
    } catch (error) {
      console.error('Error fetching blocks:', error);
      commit('SET_ERROR', error.message || 'Failed to fetch blocks');
      commit('SET_BLOCKS', []);
      throw error;
    } finally {
      commit('SET_IS_LOADING', false);
    }
  },
  async searchBlocks({ commit }, query) {
    commit('SET_IS_LOADING', true);
    commit('CLEAR_ERROR');
    try {
      const response = await blocksService.searchBlocks(query);
      commit('SET_BLOCKS', response?.items || response || []);
      return response;
    } catch (error) {
      console.error('Error searching blocks:', error);
      commit('SET_ERROR', error.message || 'Failed to search blocks');
      commit('SET_BLOCKS', []);
      throw error;
    } finally {
      commit('SET_IS_LOADING', false);
    }
  },
  async createBlock({ commit, dispatch }, payload) {
    commit('SET_IS_LOADING', true);
    commit('CLEAR_ERROR');
    try {
      const response = await blocksService.createBlock(payload);
      await dispatch('getBlocks');
      return response;
    } catch (error) {
      console.error('Error creating block:', error);
      commit('SET_ERROR', error.message || 'Failed to create block');
      throw error;
    } finally {
      commit('SET_IS_LOADING', false);
    }
  },
  async updateBlock({ commit, dispatch }, payload) {
    commit('SET_IS_LOADING', true);
    commit('CLEAR_ERROR');
    try {
      const response = await blocksService.updateBlock(payload);
      await dispatch('getBlocks');
      return response;
    } catch (error) {
      console.error('Error updating block:', error);
      commit('SET_ERROR', error.message || 'Failed to update block');
      throw error;
    } finally {
      commit('SET_IS_LOADING', false);
    }
  },
  async deleteBlock({ commit, dispatch }, blockId) {
    commit('SET_IS_LOADING', true);
    commit('CLEAR_ERROR');
    try {
      const response = await blocksService.deleteBlock(blockId);
      await dispatch('getBlocks');
      return response;
    } catch (error) {
      console.error('Error deleting block:', error);
      commit('SET_ERROR', error.message || 'Failed to delete block');
      throw error;
    } finally {
      commit('SET_IS_LOADING', false);
    }
  },
  clearError({ commit }) {
    commit('CLEAR_ERROR');
  },
};

const getters = {
  blocks: (storeState) => storeState.blocks,
  isLoading: (storeState) => storeState.isLoading,
  error: (storeState) => storeState.error,
  getBlockById: (storeState) => (id) => storeState.blocks.find((block) => block.id === id),
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
/* eslint-enable no-param-reassign */
/* eslint-enable no-unused-vars */
